export enum NotificationDuration {
    Short = 1,
    Standard = 4,
    Long = 8
}